import { useState } from 'react';
import { classNames } from '~/utils/classNames';
import { CAPTION, CARD } from '~/components/workbench/tools/payments/ui';
import {
  CLI_QUICKSTART,
  DOCS_QUICKSTART_URL,
  DOCS_THEME_URL,
  DOCS_URL,
} from '~/components/marketplace/developer-model';

/** The CLI quickstart and links into the "Build for Dunea" docs. */
export function StartBuilding() {
  return (
    <section className={classNames(CARD, 'space-y-3 p-4')}>
      <h3 className={CAPTION}>Start building</h3>
      <p className="text-[12px] leading-relaxed text-secondary">
        Scaffold a plugin, check it the way the marketplace does, then publish it for review.
      </p>
      <CodeBlock lines={CLI_QUICKSTART} />
      <div className="flex flex-wrap gap-x-4 gap-y-1.5 text-[12px]">
        <DocLink href={DOCS_URL} label="Developer docs" />
        <DocLink href={DOCS_QUICKSTART_URL} label="Plugin quickstart" />
        <DocLink href={DOCS_THEME_URL} label="Theme quickstart" />
      </div>
    </section>
  );
}

function DocLink({ href, label }: { href: string; label: string }) {
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className="inline-flex items-center gap-1 text-secondary underline decoration-subtle underline-offset-2 hover:text-primary"
    >
      {label}
      <div className="i-ph:arrow-up-right text-[11px]" />
    </a>
  );
}

function CodeBlock({ lines }: { lines: readonly string[] }) {
  const [copied, setCopied] = useState(false);
  const text = lines.join('\n');

  const copy = () => {
    void navigator.clipboard?.writeText(text);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="relative overflow-hidden rounded-lg border border-hairline bg-sunken">
      <pre className="overflow-x-auto py-2.5 pl-3 pr-10 font-geist-mono text-[11px] leading-relaxed text-primary">
        {lines.map((l) => (
          <div key={l}>
            <span className="select-none text-muted">$ </span>
            {l}
          </div>
        ))}
      </pre>
      <button
        type="button"
        onClick={copy}
        className="ui-btn-icon absolute right-1.5 top-1.5"
        title="Copy commands"
        aria-label="Copy commands"
      >
        <div className={classNames(copied ? 'i-ph:check text-accent' : 'i-ph:copy text-muted', 'text-[13px]')} />
      </button>
    </div>
  );
}
